/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateTimeCriteriaRangeRequest
 */
export interface DateTimeCriteriaRangeRequest {
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeRequest
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeRequest
     */
    to?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeCriteriaRangeRequest
     */
    exclude?: boolean;
}

export function DateTimeCriteriaRangeRequestFromJSON(json: any): DateTimeCriteriaRangeRequest {
    return DateTimeCriteriaRangeRequestFromJSONTyped(json, false);
}

export function DateTimeCriteriaRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeCriteriaRangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function DateTimeCriteriaRangeRequestToJSON(value?: DateTimeCriteriaRangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
        'exclude': value.exclude,
    };
}


